import {AnimatePresence, motion} from "framer-motion";
import {toast, toastItem} from "./index.css";
import {type ToastItem, useToastStore} from "./index.store";

function Toast() {
	const toasts = useToastStore((state) => state.toasts);

	return (
		<div className={toast}>
			<AnimatePresence>
				{toasts.map((toast) => (
					<ToastItem key={toast.id} {...toast} />
				))}
			</AnimatePresence>
		</div>
	);
}

function ToastItem({id, message, type}: ToastItem) {
	const removeToast = useToastStore((state) => state.removeToast);

	return (
		<motion.div
			layout
			className={toastItem({type})}
			initial={{y: 50, opacity: 0}}
			animate={{y: 0, opacity: 1}}
			exit={{y: 50, opacity: 0}}
			transition={{duration: 0.3}}
			onClick={() => removeToast(id)}
		>
			{message}
		</motion.div>
	);
}

Toast.info = (message: string) => {
	useToastStore.getState().addToast(message, "info");
};

Toast.success = (message: string) => {
	useToastStore.getState().addToast(message, "success");
};

Toast.error = (message: string) => {
	useToastStore.getState().addToast(message, "error");
};

export default Toast;
